module.exports = __webpack_public_path__ + "img/Montage.bbe0ba7d.svg";